// NPM Imports
import React from "react";

// Component Imports
import PricingMethodOptions from "./PricingMethodOptions";
import PricingMethodOptionsUpgrade from "./PricingMethodOptionsUpgrade";
import { FeatureGating } from "../../../../commonComponents";

export default function(props) {
  return (
    <FeatureGating
      name={props.type.featureName}
      ignore={props.type.featureIgnore}
      altComponent={
        <PricingMethodOptionsUpgrade
          featureName={props.type.featureName}
          {...props}
        />
      }>
      <PricingMethodOptions {...props} />
    </FeatureGating>
  );
}



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricingMethodWrapper/PricingMethodOptions/index.js